export const NICHES = [
  'Beauty', 'Fitness', 'Fashion', 'Haustiere', 'Home & Living', 'Gaming', 'Elektronik',
  'Schmuck', 'Babys & Kinder', 'Outdoor & Reisen', 'Gesundheit', 'Küche', 'Wählt ihr für mich',
];

export function recommendNiche({ interest, audience, price }) {
  switch (interest) {
    case 'pflege': return 'Beauty';
    case 'mode': return audience === 'frauen' && price === 'hoch' ? 'Schmuck' : 'Fashion';
    case 'sport': return price === 'hoch' ? 'Fitness' : 'Gesundheit';
    case 'zuhause':
      if (audience === 'eltern') return 'Babys & Kinder';
      return price === 'hoch' ? 'Küche' : 'Home & Living';
    case 'technik': return audience === 'maenner' ? 'Gaming' : 'Elektronik';
    case 'tiere': return 'Haustiere';
    case 'draussen': return 'Outdoor & Reisen';
    default: return 'Wählt ihr für mich';
  }
}

export function productUrlForNiche(baseUrl, niche) {
  return `${baseUrl}?nische=${encodeURIComponent(niche)}`;
}

export const QUIZ_KEYS = ['interest', 'audience', 'price', 'time', 'blocker'];

export function isQuizComplete(answers) {
  return QUIZ_KEYS.every((key) => Boolean(answers[key]));
}

export function quizResult(answers, baseUrl) {
  const niche = recommendNiche(answers);
  return {
    niche,
    open: niche === 'Wählt ihr für mich',
    url: productUrlForNiche(baseUrl, niche),
    reveal: [`time:${answers.time}`, `blocker:${answers.blocker}`],
  };
}

export function fillTemplate(template, niche) {
  return template.replaceAll('{niche}', niche);
}

if (typeof customElements !== 'undefined' && !customElements.get('sf-quiz')) {
  customElements.define('sf-quiz', class extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.result = this.querySelector('[data-quiz-result]');
      this.current = 0;
      this.addEventListener('change', (event) => {
        if (event.target.type !== 'radio') return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.next(), 280);
      });
      this.querySelector('[data-quiz-back]')?.addEventListener('click', () => this.show(Math.max(0, this.current - 1)));
      this.querySelector('[data-quiz-restart]')?.addEventListener('click', () => this.restart());
      this.show(0);
    }

    answers() {
      return Object.fromEntries(QUIZ_KEYS.map((key) => [key, this.querySelector(`input[name="${key}"]:checked`)?.value]));
    }

    next() {
      if (this.current < this.steps.length - 1) {
        this.show(this.current + 1);
        return;
      }
      const answers = this.answers();
      if (isQuizComplete(answers)) this.finish(answers);
    }

    show(index) {
      this.current = index;
      this.steps.forEach((step, i) => {
        step.hidden = i !== index;
        step.classList.toggle('is-active', i === index);
      });
      this.result.hidden = true;
      this.classList.remove('is-done');
      const total = this.steps.length;
      this.querySelector('[data-quiz-count]').textContent = `Frage ${index + 1} von ${total}`;
      this.querySelector('[data-quiz-progress]').style.width = `${((index + 1) / (total + 1)) * 100}%`;
      this.querySelector('[data-quiz-back]').hidden = index === 0;
    }

    finish(answers) {
      const result = quizResult(answers, this.dataset.productUrl);
      this.steps.forEach((step) => { step.hidden = true; });
      this.querySelector('[data-quiz-progress]').style.width = '100%';
      this.querySelector('[data-quiz-count]').textContent = 'Dein Ergebnis';
      this.querySelectorAll('[data-template]').forEach((el) => {
        const template = result.open ? el.dataset.templateOpen : el.dataset.template;
        el.textContent = fillTemplate(template, result.niche);
      });
      this.querySelectorAll('[data-reveal]').forEach((el) => { el.hidden = !result.reveal.includes(el.dataset.reveal); });
      this.querySelector('[data-quiz-link]').href = result.url;
      const meta = [...this.querySelectorAll('template[data-niche-meta]')].find((tpl) => tpl.dataset.nicheMeta === result.niche);
      const mock = this.querySelector('[data-sf-mock]');
      if (meta && mock) {
        mock.style.setProperty('--mock-accent', meta.dataset.accent);
        mock.querySelectorAll('[data-sf-mock-niche]').forEach((el) => { el.textContent = result.niche; });
        mock.querySelectorAll('.sf-phone__product').forEach((tile) => { tile.innerHTML = meta.innerHTML; });
      }
      this.result.hidden = false;
      this.classList.add('is-done');
      this.querySelector('[data-quiz-back]').hidden = true;
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    restart() {
      this.querySelectorAll('input[type="radio"]').forEach((input) => { input.checked = false; });
      this.show(0);
    }
  });
}
